import produce from 'immer';
import Raven from 'raven-js';
import { useCallback } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { useUpdateProduct } from 'products-ui-components/hooks/useUpdateProduct';
import { UpdateProductActionContext } from '../contexts/UpdateProductActionContext';
import { useProductData } from '../contexts/ProductDataContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProductMutationsProvider = ({
  onSuccess,
  children
}) => {
  const {
    product
  } = useProductData();
  const handleMutationError = useCallback(err => {
    Raven.captureException(err);
    FloatingAlertStore.addAlert({
      message: unescapedText('productUpdate.error.message'),
      titleText: unescapedText('productUpdate.error.title'),
      type: 'danger'
    });
  }, []);
  const handleUpdateSuccess = useCallback(({
    subject,
    modifiedProperties
  }) => {
    onSuccess === null || onSuccess === void 0 || onSuccess(subject, modifiedProperties);
  }, [onSuccess]);
  const updateProductMutation = useUpdateProduct({
    onUpdate: handleUpdateSuccess,
    onError: handleMutationError
  });
  const updateProductProperties = useCallback(properties => {
    if (!product) {
      const error = new Error('Product objectId is required for updates but was not defined or product was not found');
      Raven.captureException(error);
      FloatingAlertStore.addAlert({
        message: unescapedText('productUpdate.error.message'),
        titleText: unescapedText('productUpdate.error.title'),
        type: 'danger'
      });
      return;
    }
    const modifiedProperties = new Set(Object.keys(properties));
    const updatedProduct = produce(product, draft => {
      Object.entries(properties).forEach(([key, value]) => {
        draft.properties[key] = {
          name: key,
          value
        };
      });
    });
    updateProductMutation({
      subject: updatedProduct,
      modifiedProperties,
      addAnother: false
    });
  }, [product, updateProductMutation]);
  return /*#__PURE__*/_jsx(UpdateProductActionContext.Provider, {
    value: updateProductProperties,
    children: children
  });
};